import * as actions from './redux/actions';

import React, { Component, useState } from 'react';

import CommonService from '../../services/commonService';
import DateService from '../../services/dateService';
import KuposDatePicker from './KuposDatePicker';
import KuposSelectBox from './KuposSelectBox';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import getIcons from '../themes/functions/getIcons/getIcons';
import { withTranslation } from 'react-i18next';

const KuposTabs = ({ tabs, onTabChange, selectedTab, operator, width, background }) => {
	const styles = {
		tabPadding: {
			paddingTop: 15,
			paddingBottom: 15,
			width: width,
			paddingLeft: 20,
			paddingRight: 20,
		},
		active: {
			backgroundColor: '#fff',
			borderRadius: '75px',
			textAlign: 'center',
		},
	};

	return (
		<div
			className="recharge-tabs-container less-bold-text"
		// montserrat-bold"
		>
			<style>
				{operator ? `
    .active {
      background-color: ${operator.operator_name === "basetorres"
						? operator.color_codes && operator.color_codes.primary_color
						: operator.color_codes && operator.color_codes.header_color} !important;
    }
  ` : ""}
			</style>
			<div
				className="map-container-selector "
				style={{
					marginTop: 0,

					background: background ? operator.operator_name === "basetorres" ? operator.color_codes && operator.color_codes.secondary_color : operator.color_codes.sub_header_color : operator.theme_color,
					width: width ? 400 : ' ',
					fontSize: '13px',
				}}
			>

				{tabs.map((tab, key) => {
					return (
						<div
							className={'selector-item ' + (selectedTab == key + 1 ? 'active' : '')}
							onClick={() => onTabChange(key + 1)}
							style={styles.tabPadding}
						>
							{tab}
						</div>
					);
				})}
			</div>
		</div >
	);
};

/* istanbul ignore next */
function mapStateToProps(state) {
	return {
		home: state.home,
	};
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators({ ...actions }, dispatch),
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation('common')(KuposTabs));



// WEBPACK FOOTER //
// ./src/features/common/KuposTabs.js